<template lang="pug">
  .wrapper
    .homeWrap( draggable="true")
      .memberWrap(v-dragscroll draggable="true")
        img#frame1(src='/img/frame1.png')
        img#text01(src='/img/text01-1.png')
        img#h1(src='/img/h1-1.png')
        img#frame2(src='/img/frame2.png')
        img#texture01(src='/img/texture01-1.png')
        img#frame3(src='/img/frame3.png')
        img#text2(src='/img/text2-1.png')
        img#h2(src='/img/h2-1.png')
        img#frame4(src='/img/frame4.png')
        img#texture02(src='/img/texture02-1.png')
        img#text03a(src='/img/text03a-1.png')
        img#text03b(src='/img/text03b-1.png')
        img#h3(src='/img/h3-1.png')
        img#frame5(src='/img/frame5.png')
        img#texture03(src='/img/texture03-1.png')
        img#text04(src='/img/text04-1.png')
        img#h4(src='/img/h4-1.png')
        img#frame6(src='/img/frame6.png')
        img#text05a(src='/img/text05a-1.png')
        img#h5(src='/img/h5-1.png')
        img#frame7(src='/img/frame7.png')
        img#text05b(src='/img/text05b-1.png')
        img#h6(src='/img/h6-1.png')
        img#frame8(src='/img/frame8.png')
        img#text06(src='/img/text6-1.png')
        img#texture04(src='/img/texture04-1.png')
    //- bottomsmoke


</template>

<style lang="scss">
::-webkit-scrollbar {
    width: 0px;  /* remove scrollbar space */
    background: transparent;  /* optional: just make scrollbar invisible */
}
/* optional: show position indicator in red */
::-webkit-scrollbar-thumb {
    // background: #FF0000;
}
  .homeWrap{
    // overflow:auto;
    // width:100%;
    // height:100vh;
  }
  .memberWrap{
    width:100%;
    height:100vh;
    overflow:auto;
    position:relative;
    cursor:grab;
  }
  #frame1{
      position:absolute;
      top: 100px;
      left: 100px;
      z-index:0;
  }
  #text01{
      position:absolute;
      top: 120px;
      left: 120px;
      z-index:1;
  }
  #h1{
      position:absolute;
      top:190px;
      left:130px;
      z-index:0;
  }
  #frame2{
      position:absolute;
      top: 100px;
      left: 430px;
      z-index:0;
  }
  #texture01{
      position:absolute;
      top: 125px;
      left: 430px;
      z-index:0;
  }
  #frame3{
      position:absolute;
      top: 100px;
      left: 760px;
      z-index:0;
  }
  #text2{
      position:absolute;
      top: 120px;
      left: 770px;
      z-index:1;
  }
  #h2{
      position:absolute;
      top: 100px;
      left: 520px;
      z-index:0;
  }
  #frame4{
      position:absolute;
      top: 100px;
      left: 1090px;
      z-index:0;
  }
  #texture02{
      position:absolute;
      top: 250px;
      left: 1090px;
      z-index:0;
  }
  #text03a{
      position:absolute;
      top: 120px;
      left: 1170px;
      z-index:2;
  }
  #text03b{
      position:absolute;
      top: 320px;
      left: 1130px;
      z-index:2;
  }
  #h3{
      position:absolute;
      top: 125px;
      left: 1180px;
      z-index:1;
  }
  #frame5{
      position:absolute;
      top: 100px;
      left: 1420px;
      z-index:0;
  }
  #texture03{
      position:absolute;
      top: 125px;
      left: 1420px;
      z-index:0;
  }
  #text04{
      position:absolute;
      top: 320px;
      left: 1480px;
      z-index:2;
  }
  #h4{
      position:absolute;
      top: 80px;
      left: 1515px;
      z-index:1;
  }  
  #frame6{
      position:absolute;
      top: 100px;
      left: 1750px;
      z-index:0;
  }
    #text05a{
      position:absolute;
      top: 120px;
      left: 1770px;
      z-index:2;
  }
  #h5{
      position:absolute;
      top: 120px;
      left: 1800px;
      z-index:3;
  }
  #frame7{
      position:absolute;
      top: 100px;
      left: 2080px;
      z-index:0;
  }
  #text05b{
      position:absolute;
      top: 300px;
      left: 2130px;
      z-index:0;
  }
  #h6{
      position:absolute;
      top: 100px;
      left: 2200px;
      z-index:3;
  }
  #frame8{
      position:absolute;
      top: 100px;
      left: 2410px;
      z-index:0;
  }
  #text06{
      position:absolute;
      top: 120px;
      left: 2540px;
      z-index:1;
  }
  #texture04{
      position:absolute;
      top: 120px;
      left: 2635px;
      z-index:0;
  }
  @media(max-width:1440px){
    .homeWrap{
        margin-top:100px;
    }
    .memberWrap{
      margin-top:-69px;
      overflow-y:hidden;
    //   zoom:-1;
      img{
          zoom:.7;
      }
    }
  }
  @media(max-width:768px){
    // .memberWrap{
    //   margin-top:-115px;
    // }
    .homeWrap{
      margin-top:-100px;
    }
  }
  @media(max-width:320px){
    // .memberWrap{
    //   margin-top:-115px;
    // }
    .homeWrap{
      margin-top:-100px;
    }
  }
    
</style>

<script>
// @ is an alias to /src

export default {
  name: 'members',
  components: {
    // BottomSmoke,

  },
  data:function(){
    return {
    }
  },
  computed:{
  },
  watch:{
  },
  methods:{

  }
}
</script>
